export function cardSubtitle(author: string, type: string): string {
    const tag = type?.charAt(0).toUpperCase() + type?.slice(1);
    return author === '' ? tag : tag + ' • ' + author;
}
